module.exports = __webpack_public_path__ + "img/ks.a27f185f.png";